import React from 'react';

import { StepperConsumer } from '../Stepper';

function Nav(props) {
  return (
    <StepperConsumer>
      {({ steps, step, setStep }) => (
        <nav id="mtm-nav" className="small-16 large-5 large-push-11 xlarge-4 xlarge-push-12 columns">
          <ul className="menu vertical">
            {Object.keys(steps).map((stepName, index) => (
              <li key={stepName} className={[
                ...(index === step ? ['active'] : []),
                ...(steps[stepName].type === 'sub' ? ['sub'] : []),
              ].join(' ')}>
                <a onClick={() => setStep(index)}>{steps[stepName].label}</a>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </StepperConsumer>

  );
}

export default Nav;


// WEBPACK FOOTER //
// ./src/Nav/index.js